import { useCopyToClipboard } from "~/shared/hooks/useCopyToClipboard";
import { tw } from "~/utils";

interface CopyableValueProps {
  label: string;
  value: string;
  fieldName: string;
  successTitle: string;
  className?: string;
}

export const CopyableValue = ({
  label,
  value,
  fieldName,
  successTitle,
  className,
}: CopyableValueProps) => {
  const { copy } = useCopyToClipboard();

  return (
    <button
      type="button"
      aria-label={`Copy ${fieldName}: ${label}`}
      className={tw(
        "min-w-0 cursor-pointer break-words text-left hover:underline focus-visible:underline",
        className,
      )}
      onClick={() => void copy(value, successTitle)}
    >
      {label}
    </button>
  );
};
